export function isVideoType(type: string): boolean {
  return /^video\/\S+$/.test(type) || type === 'video';
}
